import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { Skeleton } from '@repo/ui/skeleton'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { getStaffGuides } from '../../../api/staff/get-staff-guides'
import GuideCard from '../../../components/pages/staff-personal-space/guide-card'
import useTranslate from '../../../lib/hooks/use-translate'

const StaffPersonalSpaceGuides = () => {
  const { t } = useTranslate()
  const { id } = useParams()

  const { data: guides, isLoading } = useQuery({
    queryKey: ['staff-guides', id],
    queryFn: () => getStaffGuides(Number(id))
  })

  return (
    <div className="flex flex-col gap-4">
      <Typography variant="h3">
        {t('staff.personal.space.my.journeys.details.tab.guide')}
      </Typography>

      <div className="flex flex-col gap-4">
        {isLoading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={index} className="w-full h-36 rounded-lg" />
          ))
        ) : guides && guides.length > 0 ? (
          guides?.map((guide) => (
            <GuideCard
              key={guide.id}
              title={guide.name}
              description={guide.description}
              imagePath={guide.picto?.path}
              pdfPath={guide.pdf.path}
            />
          ))
        ) : (
          <Typography variant="body-medium" color={tailwindColors.grey.lighter}>
            {t('staff.personal.space.my.journeys.details.tab.guide.no.guides')}
          </Typography>
        )}
      </div>
    </div>
  )
}

export default StaffPersonalSpaceGuides
